// extracted by mini-css-extract-plugin
module.exports = {"container":"xV","noResults":"yV","contact":"zV"};